<template>
  <v-container>
    <p>Welcome back! Please login to your account.</p>

    <v-form ref="form" @submit.prevent="onLogin">

      <label>Email Address</label>
      <v-text-field
        v-model="user.email"
        label="Work Email"
        single-line
        solo
        :rules="validateEmail"
        validate-on-blur />

      <label>Password</label>
      <v-text-field
        :type="showPassword ? 'text' : 'password'"
        v-model="user.password"
        label="Password"
        single-line
        solo
        :rules="validatePassword"
        validate-on-blur>

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon notranslate v-icon--link mdi theme--light"
            :class="{ 'mdi-eye': showPassword, 'mdi-eye-off': !showPassword }"
            @click="showPassword = !showPassword"
          ></button>
        </template>
      </v-text-field>

      <div class="d-flex align-center justify-space-between">
        <v-checkbox
          label="Remember Me"
          v-model="remember" />

        <router-link
          :to="{ name: 'ForgotPassword' }"
          class="default-btn text subdued"
        >Forgot Password</router-link>
      </div>

      <div class="d-flex justify-center">
        <router-link
          :to="{ name: 'TermsAndConditions' }"
          class="default-btn text subdued"
        >Terms and Conditions.</router-link>
      </div>

      <div class="button-group horizontal stretch">
        <button
          :disabled="loading"
          class="default-btn blue"
          @click.prevent="onLogin"
        >Login</button>

        <router-link
          class="default-btn blue inverse"
          :to="{ name: 'SignUp' }"
        >Sign up</router-link>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import { formMixin } from '@/mixins'

export default {
  name: 'SignIn',
  mixins: [formMixin],
  data: () => ({
    user: {},
    remember: false,
    loading: false,
    showPassword: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiDeals', 'apiUsers']),
    ...mapState('questionnaireStore', {
      dealId: 'dealId',
      isQuizCompleted: 'isQuizCompleted',
      newPhone: 'newPhone',
      newExtension: 'newExtension',
    }),
  },
  methods: {
    ...mapActions('feathers', ['login']),
    ...mapMutations('authStore', ['SET_USER_DATA']),
    ...mapMutations('questionnaireStore', ['CLEAR_NEW_PHONE']),

    async onLogin () {
      if (!this.$refs.form.validate()) return
      this.loading = true

      try {
        const response = await this.login({ ...this.user, remember: this.remember })

        this.user = response.user
        if (this.newPhone || this.newExtension) {
          await this.apiUsers.patch(this.user.id, {
            phone: this.newPhone,
            extension: this.newExtension,
          })
        }

        this.SET_USER_DATA(response.user)
        this.CLEAR_NEW_PHONE()
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `There was an issue logging in: ${error.message}`,
        })
        this.loading = false
        return
      }

      try {
        if (this.dealId) {
          await this.apiDeals.patch(this.dealId, { userId: this.user.id })
        }
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `It appears you had recently matched with a deal. There was an error associating it with your account: ${error.message || error.message}`,
        })
      }

      this.loading = false
      this.routeUserBasedOnRole()
    },

    routeUserBasedOnRole () {
      let nextRoute = this.isQuizCompleted
        ? ({ name: 'Matches', params: { dealId: this.dealId } })
        : ({ name: 'LenderResults' })

      if (this.user.role === 'admin') {
        nextRoute = { name: 'AdminDashboard' }
      }

      if (this.user.role === 'lender') {
        nextRoute = {
          name: 'OrganizationDashboard',
          params: { organizationId: this.user.organizationId },
        }
      }

      this.$router.push(nextRoute)
    },
  },
}
</script>

<style lang="scss" scoped></style>
